import React, { useMemo, memo } from 'react';
import { Form, Tabs, Typography } from '../../../../../components';
import classNames from 'classnames';
import { SourceWorkerInputFields } from './SourceWorkerInputFields';
import { SourceWorkerNetworkConfig } from './SourceWorkerNetworkConfig';

const { Title } = Typography;

const workerHasError = (form, index) => {
    for (const element of form.getFieldsError()) {
        const { name, errors } = element;
        const isSourceWorkerElement = name[0] === 'sourceWorkers';
        if (errors.length > 0 && isSourceWorkerElement && name[1] === index) {
            return true;
        }
    }
    return false;
};

const WorkerTabLabel = memo(({ index }) => (
    <Form.Item noStyle shouldUpdate>
        {(form) => (
            <span className={classNames({ 'source-workers-tabs__tab--error': workerHasError(form, index) })}>
                {`Worker ${index + 1}`}
            </span>
        )}
    </Form.Item>
));

const WorkerTabContent = memo(({ index, vmLevelEnabled }) => (
    <>
        <SourceWorkerInputFields sourceWorkerIndex={index} vmLevelEnabled={vmLevelEnabled} inWorkerTab />
        <Title level={5} className="source-worker-network-heading">
            Network Configuration
        </Title>
        <SourceWorkerNetworkConfig name={['sourceWorkers', index, 'network']} disabled={!vmLevelEnabled} />
    </>
));

export const SourceWorkerTabs = memo(({ workerCount, activeKey, onChange, vmLevelEnabled }) => {
    const items = useMemo(() => {
        const tabs = [];
        for (let index = 0; index < workerCount; index += 1) {
            tabs.push({
                key: String(index + 1),
                label: <WorkerTabLabel index={index} />,
                forceRender: true,
                children: <WorkerTabContent index={index} vmLevelEnabled={vmLevelEnabled} />,
            });
        }
        return tabs;
    }, [workerCount, vmLevelEnabled]);

    return (
        <Tabs
            type="card"
            activeKey={activeKey}
            onChange={onChange}
            className="source-workers-tabs"
            destroyOnHidden={false}
            items={items}
        />
    );
});

